interface Permission {
  module: string;
  identifier: string;
};

export const checkPermission = (module: PermissionModule, identifier: PermissionIdentifier): boolean => {
  const permissions: Permission[] = JSON.parse(localStorage.getItem("permissions") ?? "[]");

  return permissions.some(
    (permission) => permission.module === module && permission.identifier === identifier
  );
};

export const checkMultiplePermissions = (module: PermissionModule, identifiers: PermissionIdentifier[]): boolean => {
  const permissions: Permission[] = JSON.parse(localStorage.getItem("permissions") ?? "[]");

  return identifiers.some(identifier =>
    permissions.some(
      permission =>
        permission.module === module && permission.identifier === identifier
    )
  );
};

export const isRouteAllowed = (routeToCheck: string): boolean => {
  const menuData = localStorage.getItem("menuItems");
    if (!menuData) {
      return false;
    }

    const menus = JSON.parse(menuData);
    if (!Array.isArray(menus)) {
      return false;
    }

    const searchMenus = (menusList: any[]): boolean => {
      if (!Array.isArray(menusList)) return false;

      for (const menu of menusList) {
        if (menu?.route === routeToCheck) {
          return true;
        }

        if (Array.isArray(menu?.childMenus) && menu.childMenus.length > 0) {
          if (searchMenus(menu.childMenus)) {
            return true;
          }
        }
      }
      return false;
    };

    return searchMenus(menus);
};

export enum PermissionModule {
  RX = "Rx",
  INVENTORY = "Inventory",
  USER_MANAGEMENT = "UserManagement",
  Add_PATIENT_ON_RECORD_USAGE = "AddPatientOnRecordUsage"
}

export enum PermissionIdentifier {
  MANAGE_USE_UNITS = "ManageUseUnits",
  DUPLICATE_INVENTORY_ITEM = "DuplicateRx",
  EDIT_INVENTORY_ITEM = "EditRx",
  DELETE_INVENTORY_ITEM = "DeleteRx",
  ADD_INVENTORY_ITEM = "AddRx",
  INACTIVE_INVENTORY_ITEM = "InactivateRx",
  PRINT_BARCODE = "PrintBarcode",
  RECEIVE_INVENTORY = "ReceiveInventory",
  TRANSFER_INVENTORY = "TransferInventory",
  UPDATE_INVENTORY_COUNT = "UpdateCount",
  REPACK_INVENTORY = "RepackInventory",
  ADJUST_INVENTORY = "AdjustInventory",
  CHECK_NDC_ON_INTERNET = "CheckNDCOnInternet",
  VIEW_INVENTORY_REPORT = "ViewInventoryReport",
  ADD_TO_NDC_PRODUCT_MASTER = "AddToNDCProductMaster",
  CREATE_USER = "CreateUser",
  EDIT_USER = "EditUser",
  DELETE_USER = "DeleteUser",
  DUPLICATE_USER = "DuplicateUser",
  INACTIVE_USER = "InactivateUser",
  IMPORT_USER = "ImportUser",
  EXPORT_USER = "ExportUser",
  LOAD_USAGE_USER = "LoadUsage",
  RESET_PASSWORD_USER = "ResetPassword",
  ADD_PATIENT_ON_RECORD_USAGE = "AddPatientOnRecordUsage",
}
